<template>
    <v-container :fluid=fluid>
        <v-row justify="space-between">
            <v-col cols="12" md="8" lg="8" sm="8" order="2" order-md="1" order-lg="1" order-sm="1">
                <data-collect></data-collect>
            </v-col>
            <v-col cols="12" md="4" lg="4" sm="4" order="1" order-md="2" order-lg="2" order-sm="2">
                <results></results>
            </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            <p class="black--text body-2">
              На основе данных клинических рекомендаций <a href="http://cr.rosminzdrav.ru/" target="_blank">Минздрава РФ</a>
            </p>
            <div style="padding: 15px;background: rgba(0,0,0,0.05);line-height: 20px;font-size: 17px;color: #1b76d2;margin-top: 10px;text-align: left">
              <span style="font-weight: bold; font-size: 19px; padding-bottom: 5px;display: inline-block">Уважаемые коллеги,</span> <br>
              На нашем портале есть специальный раздел <a href="https://www.lvrach.ru/rub/11000046" target="_blank" style="font-weight: bold">"Кардиология"</a>,
              в котором можно ознакомиться с актуальными новостями по этой специальности, а также улучшить свои знания с помощью образовательных материалов.
              <br> Для кардиологов и терапевтов регулярно выходит тематический номер журнала "Лечащий Врач". <br>
              С архивом статей можно ознакомиться по <a href="https://www.lvrach.ru/archive" target="_blank" style="font-weight: bold">ссылке</a>.
            </div>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DataCollect from './DataCollect'
import Results from './Results'

export default {
  name: 'Home',
  components: { Results, DataCollect },
  data: () => ({
    fluid: true
  })
}
</script>

<style scoped lang="scss">
    @media (max-width: 415px) {
    }

</style>
